export default {
  npeWarning: 'Internal use only. Accounts and associated data are periodically wiped.',
  account: 'Account',
  email: 'Email',
  login: 'Login',
  logout: 'Logout',
  password: 'Password',
  register: 'Register',
  resetPassword: 'Reset password',
  resetPasswordAction: 'Reset Password',
  validEmailAddressRx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  invalidEmailAddress: 'Invalid email address',
  wrongEmailCredentials: 'Email or password is incorrect',
  communityMainMessage: (authStep) => {
    switch (authStep) {
      case '1':
        return 'Verifying email address.'
      case '2':
        return 'Validating forum access.'
      case '3':
        return 'Returning to forum.'
      default:
        return 'Please wait while we validate.'
    }
  },
  communityAuthTitles: {
    1: 'Email address',
    2: 'Forum access',
    3: 'Good to go'
  },
  forumRequiresEmailAddress: 'A verified email address is required to use our forums.',
  noEmailAddressForForum: 'Your account does not have an email address. Enter an email address and press Verify to get a verification email.',
  unverifiedEmailAddressForForum: emailAddress => `Your email address is not verified. Press Verify to receive a verification email at ${emailAddress}.`,
  verify: 'Verify',
  verificationEmailSent: emailAddress => {
    return `A verification email was sent to ${emailAddress}. Please open it and follow instructions. Check spam if an email is not received within 5 minutes. Once you're verified this page will continue with validation.`
  },
  communityAuthTimeout: 'Email verification was not detected. Press Restart Verification to start over.',
  discourseVerifyFail: 'Invalid community request',
  emailVerificationFail: 'Unable to send verification email. Try again later.',
  emailLinkingFail: 'We are unable to set this email address on your account. Enter a valid email address or try again later.',
  errorUndefinedEmailAddress: 'Enter an email address',
  errorUndefinedPassword: 'Enter a password',
  freeTrialStarted: 'Your free trial has started',
  passwordResetCheckEmailAndSpam: 'Check your email (and spam box) for reset instructions',
  restartVerification: 'Restart Verification',
  returningToForum: 'Everything checks out. Preparing for return.',
  validatingForumAccount: 'Please wait while we validate.'
}
